export const getPromisifiedActionsResults = (state) => state.promisifiedActionsResults;
//# sourceMappingURL=promisified-actions-selectors.js.map